import React from "react";
import {
	MDBModal,
	MDBModalDialog,
	MDBModalContent,
	MDBModalHeader,
	MDBModalBody,
} from "mdb-react-ui-kit";
import "./AbsModal.scss";

const AbsModal = ({
	isOpen,
	title,
	onClose,
	children,
	close,
	hideClose = false,
	disableBackdropClick, 
	subtitle = null,
	className = ""
}) => {
	return (
		isOpen && (
			<div className={className}>
				<MDBModal
					animationDirection="right"
					open={isOpen}
					tabIndex="-1"
					setOpen={onClose}
					aria-modal="true"
					role="dialog"
					className={`custom-modal-container ${className}`}
					staticBackdrop={disableBackdropClick} 
				>
					<MDBModalDialog
						position="top-right"
						size="lg"
						side
						scrollable
					>
						<MDBModalContent className={`modal-content ${className}`}>
							<MDBModalHeader>
								<span className="custom-modal-title ">
									<span className="title-text">{title}</span>
								</span>
								{subtitle && (
									<span className="custom-modal-subtitle">
										{subtitle}
									</span>
								)}
								<button
									type="button"
									className="close"
									aria-label="Close"
									onClick={close}
									hidden={hideClose}
								>
									<span aria-hidden="true">×</span>
								</button>
							</MDBModalHeader>
							<MDBModalBody className="custom-modal-body">
								{children}
							</MDBModalBody>
						</MDBModalContent>
					</MDBModalDialog>
				</MDBModal>
			</div>
		)
	);
};

export default AbsModal;